export const PERSON_MATCHING_PATTERNS_REQUEST = 'personTypes/PERSON_MATCHING_PATTERNS_REQUEST';
export const PERSON_MATCHING_PATTERNS_SUCCESS = 'personTypes/PERSON_MATCHING_PATTERNS_SUCCESS';
export const PERSON_MATCHING_PATTERNS_FAILURE = 'personTypes/PERSON_MATCHING_PATTERNS_FAILURE';
